const normalizarExpresion = (valor) => {
  if (valor === undefined || valor === null) return "";

  if (Array.isArray(valor)) {
    if (valor.length !== 1) return "";
    return normalizarExpresion(valor[0]);
  }

  if (typeof valor === "object") {
    const valores = Object.values(valor);
    if (valores.length !== 1) return "";
    return normalizarExpresion(valores[0]);
  }

  return String(valor).trim();
};

const quitarParentesisDeGrupo = (grupo) => {
  const contenido = grupo.trim();
  const abreParentesis = contenido.startsWith("(");
  const cierraParentesis = contenido.endsWith(")");

  if (abreParentesis !== cierraParentesis) return null;

  const grupoSinParentesis = abreParentesis
    ? contenido.slice(1, -1).trim()
    : contenido;

  // La sintaxis admite parentesis para delimitar grupos, no anidamiento.
  if (
    grupoSinParentesis === "" ||
    grupoSinParentesis.includes("(") ||
    grupoSinParentesis.includes(")")
  ) {
    return null;
  }

  return grupoSinParentesis;
};

export const parsearExpresionDependencia = (
  expresion,
  { permitirValoresVacios = false } = {}
) => {
  const expresionNormalizada = normalizarExpresion(expresion);
  if (expresionNormalizada === "") return [];

  const grupos = expresionNormalizada.split("||").map((grupo) => {
    const grupoSinParentesis = quitarParentesisDeGrupo(grupo);
    if (grupoSinParentesis === null) return null;

    const elementos = grupoSinParentesis
      .split("|")
      .map((elemento) => elemento.trim());

    if (!permitirValoresVacios && elementos.some((elemento) => !elemento)) {
      return null;
    }

    return elementos;
  });

  return grupos.some((grupo) => grupo === null) ? null : grupos;
};

const tieneValor = (valor) =>
  valor !== undefined &&
  valor !== null &&
  !(typeof valor === "string" && valor.trim() === "");

const obtenerOpcion = (valorFormulario, id_a) => {
  const opcion = valorFormulario?.[`${id_a}_op`];
  if (typeof opcion !== "string") return opcion;

  try {
    return JSON.parse(opcion);
  } catch (_err) {
    return undefined;
  }
};

const evaluarCondicion = ({
  id_a,
  valorEsperado,
  valorFormulario,
}) => {
  const valorActual = valorFormulario?.[id_a];

  // El vacio conserva la compatibilidad: no restringe el valor de ese campo.
  if (valorEsperado === "") return true;

  if (valorEsperado === "$any") {
    return tieneValor(valorActual);
  }

  if (valorEsperado.startsWith("$op.")) {
    const key = valorEsperado.slice("$op.".length).trim();
    if (!key) return false;

    return obtenerOpcion(valorFormulario, id_a)?.[key] === "s";
  }

  if (!tieneValor(valorActual)) return false;

  const valoresEsperados = String(valorEsperado)
    .split(",")
    .map((valor) => valor.trim());

  return valoresEsperados.includes(String(valorActual).trim());
};

export const cumpleDependencias = ({
  valorFormulario,
  configuraciones,
  valores,
}) => {
  const gruposConfiguraciones = parsearExpresionDependencia(configuraciones);

  if (gruposConfiguraciones === null) return false;
  if (gruposConfiguraciones.length === 0) return true;

  const expresionValores = normalizarExpresion(valores);
  const gruposValores = expresionValores
    ? parsearExpresionDependencia(expresionValores, {
        permitirValoresVacios: true,
      })
    : gruposConfiguraciones.map((grupo) => grupo.map(() => ""));

  if (
    gruposValores === null ||
    gruposValores.length !== gruposConfiguraciones.length ||
    gruposConfiguraciones.some(
      (grupo, indice) => grupo.length !== gruposValores[indice]?.length
    )
  ) {
    return false;
  }

  // Los grupos se relacionan con OR; las condiciones de cada grupo, con AND.
  return gruposConfiguraciones.some((grupo, indiceGrupo) =>
    grupo.every((id_a, indiceCondicion) =>
      evaluarCondicion({
        id_a,
        valorEsperado: gruposValores[indiceGrupo][indiceCondicion],
        valorFormulario,
      })
    )
  );
};
